/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Play = ["svg", defaultAttributes, [["polygon", { points: "5 3 19 12 5 21 5 3" }]]];

export { Play as default };
//# sourceMappingURL=play.js.map
